"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummarySection = exports.SummaryContent = exports.SummaryBadge = exports.StyledSummary = exports.StyledDetails = exports.IconContainer = exports.DetailsSection = exports.StyledIcon = void 0;
// components
const Card_1 = require("./Card");
const Icon_1 = __importDefault(require("../Icon/Icon"));
// styles
const Theme_1 = require("../../Theme/Theme");
// animations
const expand = Theme_1.keyframes `
  from {
    transform: scaleY(0);
  }

  to {
    transform: scaleY(1);
  }
`;
const collapse = Theme_1.keyframes `
  from {
    transform: scaleY(1);
  }

  to {
    transform: scaleY(0);
  }
`;
exports.StyledIcon = Theme_1.styled(Icon_1.default) `
  cursor: pointer;
`;
exports.DetailsSection = Theme_1.styled(Card_1.Card) `
  animation: ${(props) => (props.expanded ? expand : collapse)} 250ms linear;
  border-radius: 0px 0px 2px 2px !important;
  transform-origin: top;
  transform: ${(props) => (props.expanded ? `scaleY(1)` : 'scaleY(0)')};
  transition: height 250ms linear;
`;
exports.IconContainer = Theme_1.styled.div `
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-right: 12px;
  position: relative;
`;
exports.StyledDetails = Theme_1.styled.div `
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  transition-delay: ${(props) => (props.expanded ? `300ms` : '0ms')};
  transition: opacity 100ms linear;
  width: 100%;
`;
exports.StyledSummary = Theme_1.styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
exports.SummaryBadge = Theme_1.styled.div `
  align-items: center;
  background-color: ${(props) => props.badgeColor ? props.badgeColor : '#0091ea'};
  border-radius: 50%;
  color: #fff;
  display: flex;
  height: 24px;
  justify-content: center;
  margin-left: 19px;
  margin-right: 12px;
  width: 24px;
`;
exports.SummaryContent = Theme_1.styled.div `
  align-items: center;
  display: flex;
  width: 100%;
`;
exports.SummarySection = Theme_1.styled(Card_1.Card) `
  border-radius: 2px 2px ${(props) => (props.expanded ? '0px 0px' : '2px 2px')} !important;
  margin-bottom: 0px !important;
`;
//# sourceMappingURL=ExpandableCard.styles.js.map